import { Breadcrumbs, Link, Typography, Box } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useFormHeader } from "../../../contexts/FormHeaderContext";
import useCommon from "../../../hooks/useCommon";
import FormHeader from "../../../forms/components/FormHeader";

export default function BreadcrumbsNav({ breadCurmbs = true }) {
  const location = useLocation();
  const { formHeader } = useFormHeader();
  const { containerTitle } = useCommon();
  if (!breadCurmbs || location.pathname === "/login") return null;
  if (formHeader) {
    const { displayTitle, ...actions } = formHeader;
    return <FormHeader definition={{ title: displayTitle || containerTitle }} {...actions} />;
  }
  if (location.pathname === "/") return null;
  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs aria-label="Breadcrumb" separator={<NavigateNextIcon fontSize="small" />} sx={{ fontSize: 13 }}>
        <Link component={RouterLink} to="/" underline="hover" color="text.secondary">Dashboard</Link>
        <Typography color="text.primary" sx={{ fontSize: 13 }} aria-current="page">{containerTitle || "Details"}</Typography>
      </Breadcrumbs>
    </Box>
  );
}
